<template>
  <li
    class="mobile dormify-collection-chip__card"
    :class="[
      $blockClass(blockClass, 'card'),
      { 'is-active': isActive },
      { 'dormify-collection-chip__card--has-icon': hasIcon }
    ]"
  >
    <a
      class="dormify-collection-chip__card-link"
      :href="url"
      :aria-label="label"
      :class="$blockClass(blockClass, 'card-link')"
      @click.prevent="trackGTM"
    >
      <div
        v-if="alt"
        class="dormify-collection-chip__image-wrap"
        :class="$blockClass(blockClass, 'image-wrap')"
      >
        <div
          class="images dormify-collection-chip__image-container"
          :class="[
            $blockClass(blockClass, 'image-container'),
          ]"
        >
          <img
            class="images__image lazyload dormify-collection-chip__card-image"
            :class="{ 'dormify-collection-chip__card-image--icon': hasIcon}"
            :data-src="updateImageSize(imageSrc)"
            :src="updateImageSize(imageSrc)"
            :alt="alt"
          >

        </div>
      </div>

      <span
        class="body-1 dormify-collection-chip__card-title"
        :class="
          [
            $blockClass(blockClass, 'card-title'),
            { 'no-icon': !alt }
          ]
        "
        v-html="title"
      />
    </a>
  </li>
</template>

<script>

/**
 * Vue: Collection chips (dormify-collection-chip)
 * -----------------------------------------------------------------------------
 * A vue component to render collection category chips
 *
 */
export default {
  name: 'DormifyCollectionChip',

  props: {
    blockClass: {
      type: String,
      default: '',
    },
    context: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    url: {
      type: String,
      default: '',
    },
    imageSrc: {
      type: String,
      default: '',
    },
    alt: {
      type: String,
      default: '',
    },
    isActive: {
      type: Boolean,
      default: false,
    },
    hasIcon: {
      type: Boolean,
      default: true,
    },
  },

  methods: {

    /**
     * Track GTM event
     * @param {Object} event - Click event.
     */
    trackGTM(event) {
      const anchor = event.target.closest('a')
      if (anchor) {
        if (this.context === 'plp') {
          this.$gtmTrack('PlpChipClick', 'plp_chip_click', {
            url: window.location.origin + this.url.trim(),
            name: this.label.trim(),
          })
        }
        window.location = anchor.href
      }
    },

    /**
     * Updates the image size to fit in the chip.
     * @param {String} image - image url
     */
    updateImageSize(image) {
      const imageSized = image.replace(/\.jpg|\.png|\.gif|\.jpeg/g, function(match) {
        return `_180x${match}`
      })

      return imageSized
    },
  },
}
</script>

<style lang="scss">
@import './dormify-collection-chip';
</style>
